let UTILS = {}
UTILS.phoneValidate = (rule, value, callback) => {
  let myreg = /^[1][0-9][0-9]{9}$/
  if (value == undefined || value == '') {
    callback('手机号码不能为空')
  } else if (!myreg.test(value)) {
    callback('手机号码格式不正确')
  } else {
    callback()
  }
}
UTILS.emailPattern = () => { // eslint-disable-next-line
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}
export default UTILS


// WEBPACK FOOTER //
// ./src/utils/index.js